import React from 'react';

export default class ZoneExit extends React.Component {

    updateValue = (event, fieldName) => {
        this.props.updateEventData(this.props.index, fieldName, event.target.value)
    }

    renderResultOptions() {
        const config = this.props.game && this.props.game.configuration;
        const actions = config && config.zone_exit && config.zone_exit.actions;
        if (!actions) return null;
        return actions.map((option, i) => {
            return <option key={i} value={option.value}>{option.display_name}</option>
        });
    }

    render() {
        return (
            <div className="event-col">
                <label>Result</label>
                <select name="result" className="form-control" value={this.props.event.value} onChange={(e) => this.updateValue(e, 'value')}>
                    {this.renderResultOptions()}
                </select>
            </div>
        );
    }
}
